import React from 'react';
import { Table } from 'reactstrap';
import i18n from '@/utils/i18n';
import { Routes } from '@/utils/routes';
import { Link } from 'react-router-dom';

type ContainerStationsUpdatesProps = {
  oldStationIds: string[];
  newStationIds: string[];
};

const ContainerStationsUpdates = ({
  oldStationIds,
  newStationIds,
}: ContainerStationsUpdatesProps) => {
  let removedContainerStations = oldStationIds?.filter(
    (x: string) => !newStationIds?.includes(x),
  );
  let addedContainerStations = newStationIds?.filter(
    (x: string) => !oldStationIds?.includes(x),
  );

  const hasbeenAdded = addedContainerStations.length > 0;

  const containerStationIds = [
    ...addedContainerStations,
    ...removedContainerStations,
  ];

  return (
    <Table style={{ width: '100%', tableLayout: 'fixed' }}>
      <thead>
        <tr>
          <th>{i18n.t('OrderFulfillment:containerStation')}</th>
          <th>{i18n.t('OrderFulfillment:change')}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            {containerStationIds.map((id) => {
              return (
                <>
                  <Link to={Routes.containerStation(id)} className="ms-1">
                    {id}
                  </Link>
                  <br />
                </>
              );
            })}
          </td>
          <td>
            <div className={hasbeenAdded ? 'text-success' : 'text-danger'}>
              {hasbeenAdded
                ? i18n.t('OrderFulfillment:added')
                : i18n.t('OrderFulfillment:removed')}
            </div>
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

export default ContainerStationsUpdates;
